module.exports = "/assets/8eb23c3485b8f0c8467b3ecf8192c2bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BX.png
// module id = 1246
// module chunks = 0